var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('LayoutNavbar')],1),(_vm.isAdmin)?_c('v-row',[_c('LayoutAdminBar')],1):_vm._e(),_c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"offset-sm":"1","sm":"10"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }